import { useState } from "react";
import { useAppDispatch } from "../../../../store/hooks";
import { addLayerModalLayer } from "../../../../store/interaction";
import DoubleClickableTextLine from "./DoubleClickableTextLine";

function RowForAdding() {
  const [insertName, setInsertName] = useState(false);
  const dispatch = useAppDispatch();
  const finaliseInput = (layer: Layer) => {
    dispatch(addLayerModalLayer(layer))
  }

  return (
    <li>
      {insertName ? <DoubleClickableTextLine
        item={{ name: "New Layer", id: -1, visibility: false }}
        layerAction={finaliseInput}
        immediateEdit={true}
        setInsertNameActive={setInsertName}
      /> :
        <button className="newLayerButton" onClick={() => setInsertName(true)}>New Layer</button>}
    </li>)
}
export default RowForAdding